import { UtpCardModal, UtpCardStructure } from 'common/components';
import { FENCES_CDN_PATH } from 'landings/fences/fences-constants';
import { MaterialCalculation, Timing, AllInOne, Guarantee } from './components';

const MATERIAL_CALCULATION = {
  elementName: 'Рассчитаем материалы',
  header: {
    title: 'Рассчитаем материалы',
  },
  description: {
    text: 'учтём размеры и\u00A0пожелания',
  },
  image: {
    alt: 'Расчёт материалов',
    src: `${FENCES_CDN_PATH}/utp/material-calculation.png/material-calculation-1.png`,
  },
  modal: { content: MaterialCalculation },
};

const TIMING = {
  elementName: 'Изготовим и доставим за 10 дней',
  header: {
    title: 'Изготовим и\u00A0доставим за\u00A010\u00A0дней',
  },
  description: {
    text: 'сразу после заказа',
  },
  image: {
    alt: 'Изготовление и доставка забора',
    src: `${FENCES_CDN_PATH}/utp/timing.png/timing-1.png`,
  },
  modal: { content: Timing },
};

const ALL_IN_ONE = {
  elementName: 'Сделаем всё под ключ',
  header: {
    title: 'Сделаем всё под\u00A0ключ',
  },
  description: {
    text: 'от\u00A0замера до\u00A0монтажа',
  },
  image: {
    alt: 'Готовые заборы под ключ',
    src: `${FENCES_CDN_PATH}/utp/all-in-one.png/all-in-one-1.png`,
  },
  modal: { content: AllInOne },
  type: 'service-light',
};

const GUARANTEE = {
  elementName: 'Предоставим гарантию',
  header: {
    title: 'Предоставим гарантию',
  },
  description: {
    text: 'до\u00A050\u00A0лет на\u00A0материалы',
  },
  image: {
    alt: 'Предоставление гарантии',
    src: `${FENCES_CDN_PATH}/utp/guarantee.png/guarantee-1.png`,
  },
  modal: { content: Guarantee },
};

export const FENCES_UTP_CARD_LIST: UtpCardStructure<UtpCardModal>[] = [
  MATERIAL_CALCULATION,
  TIMING,
  ALL_IN_ONE,
  GUARANTEE,
];
